// extracted by mini-css-extract-plugin
module.exports = {"holding":"Holding_holding__2drkI"};